import { CardTemplate } from '~/editor/v2/cards/templates/types';
import {
  sanitizeTitleForSave,
  sanitizeBodyForSave,
  stripHtml
} from '~/editor/v2/cards/edit-modal/sanitization';
import imageAudioCardImage from '~/assets/editor/cards4-image-audio-card.jpg';

export const imageAudioTextCardTemplate: CardTemplate = {
  type: 'imageAudioText',
  label: 'Image + Audio + Text Card',
  cardImage: imageAudioCardImage,

  fields: [
    {
      type: 'image',
      name: 'pictures',
      label: 'Image',
      validation: { type: 'required' },
      defaultValue: null
    },
    {
      type: 'audio',
      name: 'audios',
      label: 'Audio',
      validation: { type: 'required' },
      defaultValue: null
    },
    {
      type: 'input',
      name: 'title',
      label: 'Title',
      validation: { type: 'required' },
      maxLength: 120,
      placeholder: 'Enter title',
      sanitizer: sanitizeTitleForSave,
      defaultValue: ''
    },
    {
      type: 'textarea',
      name: 'body',
      label: 'Description',
      maxLength: 1200,
      placeholder: 'Enter description',
      sanitizer: sanitizeBodyForSave,
      deserializer: stripHtml,
      defaultValue: ''
    }
  ],

  createModalTitle: 'New Card',
  editModalTitle: 'Edit Card'
};
